export default "__VITE_ASSET__69028089__"